module.exports = __webpack_public_path__ + "img/download.8e2c29f2.svg";